import { countryCodeEnum } from '@/constants/country'

export const HOW_TO_TRADE_COUNTRY = [
  countryCodeEnum.AUSTRIA,
  countryCodeEnum.BELGIUM,
  countryCodeEnum.BULGARIA,
  countryCodeEnum.CROATIA,
  countryCodeEnum.CYPRUS,
  countryCodeEnum.CZECH_REPUBLIC,
  countryCodeEnum.DENMARK,
  countryCodeEnum.ESTONIA,
  countryCodeEnum.FINLAND,
  countryCodeEnum.FRANCE,
  countryCodeEnum.GERMANY,
  countryCodeEnum.GREECE,
  countryCodeEnum.HUNGARY,
  countryCodeEnum.ICELAND,
  countryCodeEnum.IRELAND,
  countryCodeEnum.LATVIA,
  countryCodeEnum.LIECHTENSTEIN,
  countryCodeEnum.LITHUANIA,
  countryCodeEnum.LUXEMBOURG,
  countryCodeEnum.MALTA,
  countryCodeEnum.NETHERLANDS,
  countryCodeEnum.NORWAY,
  countryCodeEnum.POLAND,
  countryCodeEnum.PORTUGAL,
  countryCodeEnum.ROMANIA,
  countryCodeEnum.SLOVAKIA,
  countryCodeEnum.SLOVENIA,
  countryCodeEnum.SPAIN,
  countryCodeEnum.SWEDEN,
  countryCodeEnum.SWITZERLAND,
  countryCodeEnum.BOSNIA_AND_HERZEGOVINA,
  countryCodeEnum.GIBRALTAR,
  countryCodeEnum.VATICAN_CITY_STATE,
  countryCodeEnum.ISLE_OF_MAN,
  countryCodeEnum.MOLDOVA,
  countryCodeEnum.MONACO,
  countryCodeEnum.MONTENEGRO,
  countryCodeEnum.SAN_MARINO,
  countryCodeEnum.SERBIA,
  countryCodeEnum.FRENCH_GUIANA,
  countryCodeEnum.GUADELOUPE,
  countryCodeEnum.MARTINIQUE,
  countryCodeEnum.MAYOTTE,
  countryCodeEnum.REUNION,
]

export const COUNTRY_MIN_LIMIT = isAcuitySignalCentre => {
  switch (true) {
    case isAcuitySignalCentre:
      return 500
    default:
      return 50
  }
}
